<template>
  <section class="container section pt-0">
    <student-datatable />
  </section>
</template>

<script>
import StudentDatatable from "./student_datatable/Index.vue";

export default {
  name: "StudentIndex",
  components: { StudentDatatable },
  data() {
    return {
      is_loading: false,
    };
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    create() {
      console.log("create order");
    },
    refresh() {
      console.log("refresh orders");
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
